import { useSelector } from 'react-redux'
import { RootState } from '../redux'
import { Level } from '../types'

export default function useLevel(): Level | undefined {
  return useSelector((state: RootState) => state.levels.level)
}
